import gbaAdminExtra from './gbaAdminExtra';

export default {
  "home": "Home",
  "btn_detail": "Details",
  "follow": "Favorite",
  "degree": "degree",
  "please_placeholder": "Please select",
  "search_placeholder": "Search HCP",
  "no_data": "No data",
  "persona": "360 Profile",
  "activity": "Academic",
  "perception": "Perception",
  "more_detail": "More details",
  "no_more_data": "No more data",
  "relationship": "Relationship",
  "persona_tag": "HCP Tags",
  "assessment": "Assessment",
  "good_at": "Specialty",
  "brief": "Biography",
  "network_dynamics": "Online Reported Activity",
  "all_business_cooper": "Product Cooperation",
  "contact_preference": "Takeda Interactions",
  "top_channel": "Top Channel",
  "top_content": "Top Content",
  "perception_tag": "Perception Tag",
  "typing_history": "Segmention History",
  "every_typing": "HCP Perceptions",
  "unaccredited": "Unacepted",
  "accredited": "Accepted",
  "communication_style": "Personality Style",
  "relaxion_network": "Professional Network",
  "no_relaxion_network": "No network data",
  "show_relaxion_count": "Show amount: ",
  "activity_tag": "Academic Tags",
  "activity_summary": "Academic Summary",
  "top_activity_key": "Academic Preferences",
  "activity_article_detail": "Academic Details",
  "publication": "Publication",
  "professional": "Clinical Trial",
  "project": "NSFC Project",
  "award": "Award",
  "edit_error": "Find Bugs",
  "first_author": "First Author",
  "not_yet": "No data",
  "schedules_time": "Outpatient Time",
  "feedback_title": "Please fill in your feedback",
  "btn_cancel": "Cancel",
  "btn_prev": "Back",
  "btn_sure": "Submit",
  "old_age": "Older High",
  "old_age_standard": "Older Std",
  "middle_aged": "Mid-age High",
  "middle_aged_standard": "Mid-age Std",
  "login_txt": "Login",
  "input_name": "Please enter name",
  "input_uid": "Please enter employee ID",
  "poc_version": "POC internal version",
  "poc_version_desc": "Please login with your name and employee ID",
  "login_btn": "Login",
  "show_customers_txt": "Only listed HCPs covered in this project",
  "dosing_status": "HCO Listing",
  "clinical_trial": "Department Clinical Trials",
  "takeda_speaker": "Speaker",
  "job_details": "Details",
  "job_details_txt": "Association Positions",
  "all_time": "All",
  "one_year": "Within 1 year",
  "five_year": "Within 5 years",
  "publication_detail": "Publication Details",
  "publication_title": "Publication",
  "key_word": "Keywords",
  "organization": "Institution",
  "scope": "Scope",
  "period": "Period",
  "category": "Category",
  "study_objectives": "Objectives",
  "applier_name": "Applier",
  "indication": "Indication",
  "drug_type": "Drug Type",
  "drug_name": "Drug Name",
  "registration_date": "Registration Date",
  "applier_status": "Status",
  "applier_contact": "Applier Contact",
  "professional_subject": "Subject",
  "abstract": "Abstract",
  "authors": "Authors",
  "doi": "DOI",
  "journal_if": "Journal IF",
  "journal": "Journal",
  "source": "Source",
  "publication_time": "Publication Date",
  "thesis_title": "Subject",
  "clinical_trial_detail": "Clinical Trial Details",
  "clinical_trial_title": "Clinical Trial",
  "wechat_title": "WeChat",
  "common_product_detail": "Product Cooperation Details",
  "common_relaxion_detail": "Academic Cooperation Details",
  "publication_paper": "Publication co-author",
  "joint_test": "Clinical trial",
  "same_college": "Schoolmate",
  "same_hospital": "Colleague",
  "click_to_look": "Click on HCP or linkage to see details",
  "click_show_more": "Click to show more activities",
  "wechat_count": "WeChat",
  "websit": "Website",
  "combination": "Combined",
  "public_volume": " Volume in publications: ",
  "high": "High",
  "medium": "Medium",
  "low": "Low",
  "cancel_txt": "Cancel",
  "confirm_txt": "Confirm",
  "no_more_txt": "No more data",
  "loading_txt": "Loading…",
  "content_module": "Module: ",
  "data_from": "Data Source: ",
  "like_this": "I Like It",
  "no_like_this": "I Do Not Like It",
  "one_proposal": "I Have a Suggestion",
  "one_error": "I Found a Mistake",
  "choose_feed_type": "Select Feedback Type",
  "submit_sucess": "Submit Successfully",
  "submit_fail": "Failed to Submit",
  "common_clinical_trial": "Department Clinical Trials",
  "show_more_txt": "Show more",
  "job_list": "Positions",
  "yes": "Yes",
  "no": "No",
  "dosing_product": "Plan name",
  "dosing_listing_type": "Listing type",
  "dosing_over": "Completed",
  "dosing_no_over": "Incomplete",
  "month": "month",
  "choose_relation_type": "Select network type: ",
  "is_mm": "Is MM:",
  "all_type": "All network types",
  "filter_publication": "Filters",
  "filter_type": "Type:",
  "filter_is_mm": "Is MM:",
  "filter_author": "Author type:",
  "filter_if": "Journal IF:",
  "hcp_barrier_txt": "Note: as long as the expert does not fully accept the concept, it is regarded as \"not fully recognized\"",
  "select_filter_condition": "Select filter criteria",
  "info_from_external": "The information comes from external public data. Please refer to the official website for the actual information.",
  "info_from_open": "The information comes from external public data and is for reference only.",
  "follow_name": "Favorite HCPs",
  "search_info": "Library",
  "search_info_details": "Customer Suggestion Details",
  "search_doctor": "Search HCP",
  "search_follow_doctor": "Search Favorite HCP",
  "is_top": "Pin",
  "is_top_success": "Pinned on Top",
  "is_top_fail": "Unpinned on Top",
  "add_follow": "Add HCPs to Favorites",
  "choose_follow_txt": "Select the HCP you need to follow and click the ",
  "choose_follow_btn": " button on the right",
  "recommend": "Recommended",
  "follow_txt": "Add",
  "doctor_details": "HCP Details ",
  "barrier_customer": "Has the HCP's current perception barrier ",
  "barrier_is_solve": "been resolved?",
  "change_barrier_title": "Current perception barrier",
  "aim_picture": "Behavior Change Journey",
  "current_behavior": "Current Behavior",
  "behavior_dangerous": "预后评估及危险分层",
  "behavior_programme": "常规治疗方案选择",
  "behavior_treatment": "随访检测及治疗评估",
  "behavior_time": "方案调整时机",
  "behavior_now": "Current behavior",
  "behavior_pathient": "患者管理",
  "communication_suggestions": "Next Best Action Recommendation",
  "hide_more": "Hide more",
  "no_more_suggest": "No more suggestions according to the customer's current target behavior.",
  "no_more_suggest_update": "Please evaluate whether the customer's segmentation and behavior are needed to be updated. < br / >\r\nYou can also go to information retrieval to find appropriate suggestions. ",
  "no_more_suggest_if": "If the problem is not solved,",
  "no_more_suggest_help": "You can ask for DM coaching",
  "communication_style_txt": "Personality Style",
  "communication_style_disc": "DISC personality model: ",
  "communication_style_btn": "Please choose personality style",
  "is_adopt": "Suggestion accepted",
  "click_show_more_filter": "More filters",
  "click_hide_more_filter": "Hide more filters",
  "patient_type_screening": "Search by patient situation",
  "patient_type_age": "Choose patient age range",
  "patient_type_dangerous": "Choose patient risk level",
  "patient_type_body": "Choose patient health situation",
  "patient_type_type": "Choose patient treatment stage",
  "patient_type_disease": "Choose patient course of disease",
  "patient_type_filter": "Search by HCP perception barrier",
  "suggest_patient_type": "Patient type",
  "suggest_patient_solve": " ",
  "suggest_patient_barrier_content": "Current perception barrier",
  "suggest_patient_physician_challenge": "Difficulties",
  "suggest_patient_physician_action": "Actions",
  "suggest_patient_transmit": " ",
  "suggest_patient_key_message": "Suggested key message",
  "suggest_patient_aim": "Next target behavior",
  "suggest_patient_content_title": "Supported content",
  "suggest_patient_content_none": "No content",
  "suggest_patient_communicate": "Personality",
  "suggest_patient_like": "Do",
  "suggest_patient_unlike": "Not do",
  "suggest_key_info": "Suggested Key Information",
  "suggest_key_find": "Found",
  "suggest_key_fit": "Key Messages",
  "tips_title": " ",
  "no_next_suggest": "No More Suggestion",
  "make_sure_next": "Confirm to change",
  "key_message": " key message",
  "use_content": " content",
  "make_sure_follow": "Are you sure to remove from favorites?",
  "go_hcp": "Continue to HCP360 profile?",
  "has_aim_to": "Target behavior archieved. Please re-evaluate customer segmentation.",
  "answer_qust": "Please answer the following two questions for HCP segmentation:",
  "info_is_update": "HCP information updated. Suggestion recalculating…",
  "send_sucess": "Push successfully",
  "send_fail": "Push failed",
  "make_sure_send": "Please confirm whether to",
  "make_sure_send1": "Send Wuyi Space article \"",
  "make_sure_send2": "\"?",
  "visit_feedback": "Call Feedback",
  "customer_barrier": "HCP perception barrier",
  "select_reason": "Please select a reason for not accepting the recommendation",
  "behavior_stage": "Behavior Stage",
  "current_behavior_stage": "Current Behavior Stage",
  "has_arrow": "  ",
  "has_month": "/",
  "has_day": " ",
  "has_day_advice": " Suggestion Accepted",
  "has_day_accept": " Coaching Accepted",
  "has_day_over": " Coaching Completed",
  "has_visited": " Call Completed",
  "barrier_progress": "Perception barrier resolution",
  "barrier_keyinfo_feddback": "Customer feedback on key messages",
  "barrier_familiar": "Customer content familiarity",
  "barrier_assessment": "Please assess the client's acceptance of perception barrier:",
  "agreen_no": "Not",
  "agreen_ok": "Fully accepted",
  "agreen_no_approval": "Not",
  "agreen_approval": "Fully recognized",
  "agreen_no_follow_up": "Do not follow up",
  "agreen_follow_up": "Follow up",
  "tips_typing": "Please answer the questions for HCP segmentation",
  "tips_typing_error": "Segmentation failed, please answer the question again",
  "tips_style_error": "Personality style submission failed",
  "tips_answer_must": "Please answer the question first",
  "tips_feedback_error": "Feedback failure",
  "tips_thanks": "Thank you for your adoption!",
  "tips_segment": "Confirm segmentation",
  "tips_behavior": "Confirm current behavior",
  "tips_communicationstyle": "Confirm personality style",
  "slove_difficulty": "There are difficulties solving current perception barrier,",
  "slove_help": "Coaching request has been sent to DM.",
  "hcp_visit_list_covisit_tab": "Co-visits",
  "hcp_visit_list_create_visit": "New Visit",
  "hcp_visit_list_create_covisit": "New Co-visit",
  "hcp_visit_list_draft_banner": "There are currently {count} unsubmitted {type} drafts. Please complete and submit them as soon as possible.",
  "hcp_visit_draft_tag": "Draft",
  "hcp_visit_diner_tag": "Meal",
  "hcp_visit_companion_label": "Co-call partners: ",
  "hcp_visit_companion_field": "Co-call partners (optional)",
  "hcp_visit_joint_tag": "Co-call",
  "hcp_visit_participant_tag": "I'm joining",
  "hcp_visit_owner_label": "Created by: {name}",
  "hcp_visit_owner_role": "Created by",
  "hcp_visit_companion_role": "Partners",
  "hcp_visit_current_user_tag": "Me",
  "hcp_visit_companion_selector_title": "Select co-call partners",
  "hcp_visit_create_joint_action": "New call/co-call",
  "hcp_visit_customer_placeholder": "Select a customer",
  "hcp_visit_date_placeholder": "Select a call date",
  "hcp_visit_time_placeholder": "Select a call time",
  "hcp_visit_type_placeholder": "Select a call type",
  "hcp_visit_companion_placeholder": "Select co-call partners",
  "hcp_visit_companion_helper": "Adding partners makes this a co-call",
  "hcp_visit_goal_placeholder": "Select a call goal",
  "user_selector_title": "Select people",
  "user_selector_selected_count": "{count} selected",
  "user_selector_search_placeholder": "Search by name",
  "user_selector_unknown_department": "Other departments",
  "hcp_visit_unselected_physician": "No physician selected",
  "hcp_visit_feedback_count": "{count} feedback",
  "hcp_visit_feedback_author": "Feedback by: {name}",
  "hcp_visit_view_title": "View Visit",
  "hcp_visit_delete_draft_action": "Delete draft",
  "hcp_visit_draft_dialog_title": "Notice",
  "hcp_visit_draft_auto_saved_confirm_back": "Your current content has not been submitted, but it has been auto-saved as a draft. Are you sure you want to go back?",
  "hcp_visit_delete_draft_confirm": "Delete the current draft?",
  "hcp_visit_draft_deleted": "Draft deleted",
  "current_customer_txt": "Based on HCP's personality type ",
  "current_customer_style": " ",
  "will_doing": "Todo List",
  "already_confirm": "Confirmed",
  "already_refuse": "Rejected",
  "already_make_true": "To be confirmed",
  "question_txt": "(the update of segmentation will be submitted to DM for confirmation)",
  "question_choose_pi": "客户认为患者的持续治疗是有必要的吗？客户会为了实现患者更深的缓解而选择PI进行持续治疗吗？",
  "question_pi_percent": "(PI的持续治疗比例为40%，低于40%认定为否)",
  "question_v_based": "对于初次使用V-based方案，为了实现患者的长期获益，你会在4个月内转换I-based方案吗？",
  "question_v_i": "(30%V转I，认定为是)",
  "no_follow_doctor": "There is no favorite HCP.",
  "no_follow_doctor_desc": "Please add the HCPs you want to follow.",
  "coaching_completed": "Complete Coaching",
  "btn_feedback": "Feedback",
  "btn_next": "Next",
  "btn_change": "Change",
  "btn_plan_visit": "Plan a call",
  "btn_update": "Update",
  "btn_article": "Send to HCP",
  "btn_submit": "Submit",
  "btn_edit": "Edit",
  "btn_add_barrier": "Fill in perception barriers",
  "btn_is_solve": "Resolved",
  "btn_no_solve": "Not resolved, ask for coaching",
  "btn_change_solve": "Not resolved, skip to next",
  "btn_change_one": "Change perception barrier",
  "btn_give_up_follow": "Cancel",
  "btn_make_sure_follow": "Confirm and follow",
  "btn_go_hcp": "HCP360",
  "btn_need_help": "Require Coaching",
  "btn_make_perception": "Confirming Segmentation",
  "btn_make_behavior": "Confirming Behavior",
  "btn_confirm": "Confirm",
  "btn_refuse": "Reject",
  "btn_close": "Close",
  "btn_communication_style": "Confirming Personality Style",
  "task_quarter_progress": "Quarterly Promotion Progress",
  "task_view_detail": "View Detail",
  "task_quarter_deadline": "Quarter Deadline: ",
  "task_completed_forward": "Completed Forwards",
  "task_target_forward": "Target Forwards",
  "task_view_all_articles": "View All Articles",
  "task_filter_product": "Filter Product",
  "task_filter_task": "Filter Task",
  "task_no_more_task": "No more tasks",
  "task_all_task": "All Tasks",
  "task_all_product": "All Products",
  "task_executed_task": "Executed Tasks",
  "task_ignored_task": "Ignored Tasks",
  "task_type_task": " Task",
  "task_deadline": "Deadline: ",
  "task_meeting_time": "Meeting Time: ",
  "task_preview": "Preview",
  "task_recommend_reason": "Recommendation Reason: ",
  "task_target_doctor": "Target Doctor",
  "task_target_doctor_suffix": " Target Doctor",
  "task_star_indicate": "Star indicates ",
  "task_priority_recommend": "Priority Recommendation ",
  "task_executed": "Executed",
  "task_ignored": "Ignored",
  "task_invite": "Invite",
  "task_send": "Send",
  "task_visit": "Call",
  "task_fill": "Fill",
  "task_modify": "Modify",
  "task_reinvite": "Re-invite",
  "task_resend": "Re-send",
  "task_interaction_detail": "Interaction Detail",
  "task_browse": "Browse",
  "task_no_interaction": "No interaction record",
  "task_ignore_success": "Task ignored",
  "task_confirm_operation": "Confirm Operation",
  "task_confirm_ignore": "Are you sure to ignore this task?",
  "task_ignore_fail": "Failed to ignore task, please try again later",
  "task_execute_success": "Task executed",
  "task_execute_fail": "Failed to execute task, please try again later",
  "task_resend_success": "Task resent",
  "task_resend_fail": "Failed to resend task, please try again later",
  "task_send_fail": "Failed to send content, please try again later",
  "task_forward_fail": "Failed to forward, please try again later",
  "task_suggest_wording": "Suggested Wording",
  "task_copy_wording": "Copy Wording",
  "task_skip": "Skip",
  "task_copy_fail": "Failed to copy",
  "task_content_preview": "Content Preview",
  "task_live": "Webinar",
  "task_survey": "Survey",
  "task_doctor_survey": "HCP Survey",
  "task_tweet": "Content Push",
  "task_other": "Other",
  "task_execution_detail": "Task Execution Detail",
  "task_data_overview": "Data Overview",
  "task_quarter_send": "Quarter Send",
  "task_quarter_open": "Quarter Open",
  "task_kpi_updated_yesterday": "Data updated as of yesterday",
  "task_times": " times",
  "task_open": "Open",
  "task_month": " Month",
  "ai_assistant": "Ask AI",
  "ai_thinking": "Thinking",
  "ai_thinking_context": "Flipping through context",
  "ai_thinking_lookup": "Picking up the clues",
  "ai_thinking_answer": "Tidying up the answer",
  "ai_thinking_default": "Instant",
  "ai_thinking_toggle": "Thinking",
  "ai_thought_process": "Thinking process",
  "ai_thought_seconds": "Thought for {seconds}s",
  "ai_show_more": "Show more...",
  "ai_show_less": "Show less...",
  "ai_copy_answer": "Copy answer",
  "ai_copy_success": "Copied",
  "ai_copy_fail": "Failed to copy",
  "history_title": "Chat History",
  "no_history": "No history yet",
  "suggestions_and_inquiries": "Suggestions and Inquiries",
  "next_visit_suggestion": "Who should I call next",
  "vyepti_advantage": "What are Vyepti's key advantages",
  "xx_updates": "What are Dr. XX's recent updates",
  "visit_prep": "How to prepare for Dr. XX's call today",
  "ai_sales_question_next_visit": "Which customer should I visit next",
  "ai_sales_question_customer_updates": "Which recent customer updates need my attention",
  "ai_sales_question_visit_prep": "How should I prepare for today's customer visits",
  "ai_sales_manager_question_team_performance": "How is the team tracking against goals this month",
  "ai_sales_manager_question_coaching_focus": "Which regions or representatives need focused coaching",
  "ai_sales_manager_question_priorities": "Which customers and actions should the team prioritize next",
  "ai_gba_question_next_customer": "Which clinical customer should I prioritize next",
  "ai_gba_question_customer_updates": "What recent clinical customer updates need my attention",
  "ai_gba_question_ga_collaboration": "Which customers should I advance in collaboration with GA",
  "ai_ga_question_next_expert": "Which expert should I prioritize next",
  "ai_ga_question_expert_updates": "What recent expert updates need my attention",
  "ai_ga_question_gba_collaboration": "Which experts or projects should I advance in collaboration with GBA",
  "ai_gba_admin_question_team_execution": "How are the GBA and GA teams executing this week",
  "ai_gba_admin_question_attention": "Which regions or team members need attention",
  "ai_gba_admin_question_collaboration": "What cross-team opportunities and risks need attention",
  "placeholder_ai_assistant": "Ask AI",
  "placeholder_smart_qa": "Smart Q&A",
  "placeholder_ai_visit": "AI Call Log",
  "placeholder_ai_suggestion": "AI Suggestions",
  "prompt_delete_session": "Are you sure you want to delete this session?",
  "prompt_delete_success": "Deleted successfully",
  "prompt_delete_fail": "Delete failed",
  "prompt_hint": "Tip",
  "kpi_completion": "KPI Completion",
  "kpi_detail_entry_title": "View KPI Details",
  "kpi_detail_entry_desc": "Shows process metrics currently available from system data",
  "kpi_tap_to_view": "Tap to view details",
  "target_achievement_rate": "Target Achievement",
  "recent_updates": "Recent Updates",
  "no_recent_updates": "No recent updates",
  "week_task": "Current Tasks",
  "total_task": "Total",
  "completed_task": "Completed",
  "go_to_complete": "Go to Tasks",
  "task_more_doctors": "and {count} more",
  "highest_priority": "Highest Priority",
  "loading_tasks_text": "Loading tasks...",
  "task_type_conference": "Webinar",
  "task_type_survey": "Survey",
  "task_type_hcp_survey": "HCP Survey",
  "task_type_visit": "Call",
  "task_type_content": "Content",
  "task_type_call": "Call",
  "task_type_segment": "Survey",
  "task_type_other": "Other",
  "plan_visit": "Plan Call",
  "send": "Send",
  "send_content": "Send Content",
  "recommended_content": "Recommended Content",
  "select_approved_content": "Select approved content",
  "go_to_all_tasks": "Go to Current Tasks",
  "loading": "Loading...",
  "sending": "Sending...",
  "recommended_wording": "Recommended Wording",
  "copy_wording": "Copy Wording",
  "skip": "Skip",
  "copy_failed": "Copy Failed",
  "task_resent": "Task Re-sent",
  "re_send_failed": "Failed to re-send task, please try again later",
  "send_content_failed": "Failed to send content, please try again later",
  "get_content_failed": "Failed to get content",
  "forward_failed": "Forward failed, please try again later",
  "no_preview_content": "No preview available",
  "btn_save": "Save",
  "visit_info": "Call Info",
  "expense_info": "Expense Info",
  "select_key_message": "Select Key Message",
  "brintellix_strategy_map": "Brintellix Strategy Map",
  "azilect_strategy_map": "Azilect Strategy Map",
  "expense_info_title": "Expense Information",
  "delete_expense": "Delete Expense",
  "expense_desc": "If this call involves expense reimbursement, <br /> please add expense details here.",
  "add_expense": "Add Expense",
  "co_visit": "Co-call",
  "visit": "Call",
  "create": "Create",
  "edit_btn": "Edit",
  "delete_btn": "Delete",
  "visit_customer": "Customer",
  "visit_date": "Date",
  "visit_time": "Time",
  "visit_type": "Type",
  "co_visit_colleague": "Co-call partners (optional)",
  "visit_goal": "Goal",
  "involved_product": "Products",
  "visit_date_limit": "Call date cannot be earlier than 7 days ago",
  "visit_date_limit_gba": "Call date cannot be earlier than 14 days ago",
  "fill_key_message": "Please select key message",
  "expense_date_limit": "Cannot create an expense call earlier than today",
  "expense_product_limit": "Expense call must include at least one product",
  "expense_limit_300": "Estimated expense cannot exceed 300 per person",
  "expense_limit_ytd": "Estimated expense cannot exceed YTD balance",
  "expense_product_proportion": "Total product proportion must be 100%",
  "save_success": "Saved Successfully",
  "create_success": "Created Successfully",
  "delete_success": "Deleted Successfully",
  "delete_fail": "Delete Failed",
  "save_fail": "Save Failed",
  "save_network_error": "Network connection failed. Check your connection and try again.",
  "save_timeout_error": "The request timed out. Please try again later.",
  "save_auth_error": "Your session has expired. Sign in again and retry.",
  "save_permission_error": "Your account does not have permission to perform this action.",
  "save_payload_too_large": "The submitted content is too large. Reduce it and try again.",
  "save_server_error": "The service is temporarily unavailable. Please try again later.",
  "save_unknown_error": "No error details were returned. Please try again later.",
  "confirm_delete_record": "Are you sure you want to delete this record?",
  "confirm_back": "Content not saved, confirm to go back?",
  "prompt_title": "Prompt",
  "morning": "Morning",
  "afternoon": "Afternoon",
  "full_day": "All Day",
  "question_label": "",
  "input_feedback_placeholder": "Enter feedback...",
  "voice_to_text_loading": "Transcribing...",
  "ai_extracting": "AI is extracting key info...",
  "default_suggestion": "Enter feedback by voice. Click '+Question' to link topics.",
  "suggestion_prefix": "Follow up: ",
  "select_key_topic_title": "Select Key Topic/Question",
  "no_key_questions": "No key questions available",
  "confirm_delete_feedback": "Are you sure you want to delete this feedback?",
  "ai_summary_failed": "AI summary failed",
  "ai_summary_failed_retry": "AI summary failed. Please try again later.",
  "ai_summary_generating": "AI is generating the summary...",
  "ai_summary_empty": "No summary content available to save.",
  "ai_summary_api_missing": "AI summary API is not configured.",
  "ai_visit_summary_title": "AI Call Summary",
  "add_related_question": "Add related question",
  "ai_summary_label": "AI Smart Summary",
  "original_feedback_label": "Original feedback",
  "speech_subtitle": "Please describe call feedback naturally",
  "key_feedback_question_type_single": "Single Choice",
  "key_feedback_question_type_multiple": "Multiple Choice",
  "key_feedback_question_type_voice": "Voice",
  "clinical_doctor": "Physician",
  "he_expert": "HEOR Expert",
  "click_to_search_filter": "Click to search and filter",
  "filter": "Filter",
  "no_clinical_doctor": "No physicians found",
  "no_he_expert": "No HEOR experts found",
  "hcp_home_doctor_list_tab": "HCP List",
  "hcp_home_hospital_list_tab": "Hospital List",
  "hcp_hospital_list_search_placeholder": "Search hospitals",
  "hcp_hospital_list_search_button": "Search",
  "hcp_hospital_list_count": "Hospital Count: ",
  "hcp_hospital_list_search_desc": "Search by hospital name.",
  "kol_list_search_placeholder": "Search hospital/department/HCP",
  "kol_list_questionnaire_completed": "Questionnaires Completed",
  "kol_list_questionnaire_pending": "Questionnaires Pending",
  "kol_list_questionnaire_completion_rate": "Questionnaire Completion Rate",
  "doctor_count": "Count: ",
  "search_desc_title": "Search Guide",
  "search_desc_content": "Search by hospital name, department, physician name, product or segment.",
  "sort_desc_title": "Sort Guide",
  "sort_by_name": "By Name:",
  "sort_by_name_desc": "Sort by pinyin of physician name",
  "sort_by_hospital": "By Hospital:",
  "sort_by_hospital_desc": "Sort by pinyin of hospital name",
  "sort_by_level": "By Level:",
  "sort_by_level_desc": "Sort by ABC level (Only available when product is selected)",
  "hcp_list_default_sort": "Default:",
  "hcp_list_default_sort_desc": "Sort by favorite status first, then by physician name pinyin",
  "hcp_list_default_sort_option": "Default",
  "hcp_list_sort_by_hospital_option": "By Hospital",
  "search_keyword": "Keyword",
  "enter_keyword": "Enter keyword",
  "hcp_list_is_target_doctor": "Target HCP",
  "hcp_list_segment": "Perception Segment",
  "hcp_list_sales_class": "Sales Class",
  "is_favorite": "Favorite",
  "is_covered": "Covered",
  "is_wechat_bound": "WeChat Bound",
  "is_consent_signed": "Consent Signed",
  "back": "Back",
  "reset": "Reset",
  "hcp_list_all_customers": "All My HCPs",
  "hcp_list_wechat_doctor_count": "WeChat-bound HCPs: ",
  "hcp_list_target": "Target",
  "hcp_list_non_target": "Non-target",
  "hcp_list_class_suffix": " Class",
  "hcp_list_bound": "Bound",
  "hcp_list_unbound": "Unbound",
  "hcp_list_consented": "Consented",
  "hcp_list_not_consented": "Not Consented",
  "hcp_list_filter_prompt_prefix": ": ",
  "hcp_list_filter_prompt_separator": ", ",
  "hcp_list_segment_waiter": "Watcher",
  "hcp_list_segment_trier": "Trier",
  "hcp_list_segment_advocate": "Advocate",
  "all_products": "All Products",
  "all_segments": "All Segments",
  "favorite": "Favorite",
  "not_favorite": "Not Favorite",
  "covered": "Covered",
  "not_covered": "Not Covered",
  "wechat_bound": "WeChat Bound",
  "wechat_not_bound": "WeChat Not Bound",
  "consent_signed": "Consent Signed",
  "consent_not_signed": "Consent Not Signed",
  "filter_product_placeholder": "Product",
  "filter_event_placeholder": "Task",
  "no_more_task": "No more tasks",
  "meeting_time": "Meeting Time",
  "preview": "Preview",
  "recommended_reason": "Reason",
  "mark": "",
  "indicates": " indicates ",
  "invite": "Invite",
  "fill_in": "Fill",
  "executed": "Executed",
  "ignored": "Ignored",
  "re_invite": "Re-invite",
  "re_send": "Re-send",
  "modify": "Modify",
  "interaction_details": "Interaction Details",
  "browse": "Browse",
  "no_interaction_history": "No interaction history",
  "content_preview": "Preview",
  "all_tasks": "All Tasks",
  "target_hcp": "Target HCP",
  "priority_recommend": "Priority",
  "confirm_operation": "Confirm Operation",
  "confirm_ignore_task": "Are you sure you want to ignore this task?",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "ignore_task_failed": "Failed to ignore task, please try again later",
  "execute_task_failed": "Failed to execute task, please try again later",
  "recommended_script": "Recommended Script",
  "copy_script": "Copy Script",
  "male": "Male",
  "female": "Female",
  "unknown": "Unknown",
  "ai_intro": "I am your AI assistant, helping you work more efficiently",
  "quick_workflow": "Quick Workflow",
  "workflow_example": "💡 E.g. \"Record a call for me\":",
  "workflow_guide_content": "Tell me the <b>customer name</b>, <b>call time</b>; if the call is completed, the full <b>doctor feedback</b>.",
  "input_placeholder": "Type your question...",
  "call_strategy": "Next-Best-Action(s)",
  "nba_suggestions": "NBA Suggestions",
  "suggested_nba": "AI Suggested Actions",
  "no_recommended_nba": "No recommended actions",
  "nba_suggestions_generating_preview": "AI is creating suggestions. Actions are temporarily disabled.",
  "nba_generated_just_now": "Generated just now",
  "nba_generated_minute_ago": "Generated 1 minute ago",
  "nba_generated_minutes_ago": "Generated {count} minutes ago",
  "nba_generated_hour_ago": "Generated 1 hour ago",
  "nba_generated_hours_ago": "Generated {count} hours ago",
  "nba_generated_day_ago": "Generated 1 day ago",
  "nba_generated_days_ago": "Generated {count} days ago",
  "nba_generated_date": "Generated on {date}",
  "suggested_visit": "AI Suggestion",
  "suggestion_position": "{current} of {total}",
  "no_recommended_visit": "No recommended calls",
  "ask_ai_helper": "Ask AI to Prepare Call",
  "ask_ai_prepare_action": "Ask AI to Prepare",
  "ask_ai_prepare_content": "Ask AI for Content",
  "last_visit_prefix": "Last call ",
  "last_visit_suffix": "Latest Engagement",
  "no_visit_record": "No recent engagement",
  "over_days_no_visit": "No engagement for {days} days",
  "recommend_reason": "Reason: ",
  "create_visit_plan": "Create Call",
  "content_sent": "Already Sent",
  "customer_overview": "Customer Overview",
  "visit_summary": "Call Summary",
  "recent_visit_summary": "Recent Call Summary",
  "no_clear_feedback": "No clear feedback",
  "visited": "Already Done",
  "not_suitable": "Not Suitable",
  "reject_reason_recent_visit": "Recently Called",
  "reject_reason_inconvenient": "Inconvenient",
  "reject_reason_irrelevant": "Irrelevant Topic",
  "reject_reason_no_demand": "No Demand",
  "reject_reason_other": "Other Reason",
  "no_recommendation": "No Recommendation",
  "loading_strategy": "Loading strategy...",
  "tab_workbench": "Workbench",
  "tab_customer": "HCPs",
  "tab_visit": "Call",
  "tab_task": "Tasks",
  "tab_team": "Team",
  "tab_live": "Webinar",
  "tab_content": "Content",
  "close": "Close",
  "language_zh": "Chinese",
  "language_switched_zh": "已切换至中文",
  "language_switched_en": "Switched to English",
  "user_info_title": "Current User Info",
  "user_info_name": "User Name",
  "user_info_id": "User ID",
  "user_info_current_role": "Current Role",
  "user_info_language": "Language",
  "role_admin": "Admin",
  "role_marketing": "Marketing",
  "role_ga_admin": "GA Admin",
  "role_sales": "Sales",
  "role_switch_description": "Switch current role",
  "role_switching": "Switching...",
  "role_switch_success": "Switched to {role}",
  "role_switch_failed": "Failed to switch role",
  "execute_failed": "Execution failed",
  "manager_overview_team": "Team",
  "manager_overview_report_subtitle": "{role} Team Execution Report",
  "manager_overview_scope_national": "National",
  "manager_overview_scope_area": "Area: {scope}",
  "manager_overview_scope_district": "District: {scope}",
  "manager_overview_members": "Members",
  "manager_overview_abc_customers": "A/B/C Customers",
  "manager_overview_abc_coverage": "A/B/C Coverage",
  "manager_overview_no_permission": "The current account is not a DM/AM/SD manager role and has no team report access.",
  "manager_overview_tab_overview": "Overview",
  "manager_overview_tab_team": "Team",
  "manager_overview_tab_analysis": "Analysis",
  "manager_overview_loading_title": "Loading team data",
  "manager_overview_loading_step": "Loading {step}",
  "manager_overview_loading_position": "Item {current}/{total}",
  "manager_overview_loading_modules": "{completed}/{total} data modules completed",
  "manager_overview_loading_members": "Estimated scope: {count} subordinates",
  "manager_overview_loading_rows": "{count} data records fetched",
  "manager_overview_loading_hierarchy": "Fetching subordinate team",
  "manager_overview_loading_parallel": "Fetching statistics in parallel",
  "manager_overview_loading_feedback": "Call feedback stats",
  "manager_overview_loading_coverage": "Customer coverage and call stats",
  "manager_overview_loading_content": "Content push stats",
  "manager_overview_loading_target_customers": "All target customers",
  "manager_overview_loading_abc_target_customers": "A/B/C target customers",
  "manager_overview_loading_product_targets": "Product target customers",
  "manager_overview_loading_product_segments": "Customer perception segments",
  "manager_overview_loading_segment_defs": "Segment definitions",
  "manager_overview_loading_team_detail": "Loading team member details",
  "manager_overview_loading_analysis": "Loading analysis data",
  "manager_overview_loading_tasks": "Task stats",
  "manager_overview_loading_nba": "NBA suggestion stats",
  "manager_overview_loading_nba_feedback": "NBA feedback stats",
  "manager_overview_loading_finalize": "Preparing report view",
  "manager_overview_execution_overview": "Team Execution Overview",
  "manager_overview_execution_quality": "Team Execution Quality",
  "manager_overview_analysis_title": "Team Analysis",
  "manager_overview_analysis_desc": "Review team opportunities and risks by product and customer perception segment.",
  "manager_overview_segment_overview": "Customer Perception Segment Overview",
  "manager_overview_segment_desc": "View physician perception stage distribution by product based on all target customers.",
  "manager_overview_ai_analysis": "Analyze with AI",
  "manager_overview_current_latest": "Current Latest",
  "manager_overview_abc_target_customers_count": "Target Customers {count}",
  "manager_overview_segment_distribution_aria": "{product} physician segment distribution",
  "manager_overview_segment_label": "{segment} {count} ({share})",
  "manager_overview_no_product_segment_data": "No product or customer segment data",
  "manager_overview_member_execution": "Team Member Execution",
  "manager_overview_member_desc": "Tap a member header to view personal execution details",
  "manager_overview_member_current_display": ", showing {filtered}/{total} members",
  "manager_overview_no_territory": "No territory info",
  "manager_overview_abc_customer_coverage": "A/B/C Customer Coverage",
  "manager_overview_target_customer_coverage": "Target coverage",
  "manager_overview_abc_coverage_short": "A/B/C coverage",
  "manager_overview_abc_coverage_breakdown": "A/B/C Customer Coverage Detail",
  "manager_overview_abc_coverage_breakdown_desc": "Keep the combined A/B/C coverage and review target, covered, and coverage rate by customer level.",
  "manager_overview_abc_coverage_total": "A/B/C Total",
  "manager_overview_target_customer_coverage_with_rate": "Target coverage · {rate}",
  "manager_overview_abc_customer_coverage_with_rate": "A/B/C coverage · {rate}",
  "manager_overview_coverage_rate": "Coverage",
  "manager_overview_calls": "Calls",
  "manager_overview_call_feedback": "Call Feedback",
  "manager_overview_content_push": "Content Push",
  "manager_overview_content_open": "Target Opens",
  "manager_overview_content_open_send": "Content Open/Send",
  "manager_overview_task_execution": "Task Execution",
  "manager_overview_nba_execution": "NBA Execution",
  "manager_overview_product_coverage_prefix": "Customer coverage by product: ",
  "manager_overview_no_filtered_member_data": "No subordinate execution data for current filters",
  "manager_overview_personal_detail": "Personal Details",
  "manager_overview_product_abc_coverage": "Product A/B/C Customer Coverage",
  "manager_overview_product_target_coverage": "Product Target Customer Coverage",
  "manager_overview_customer_count_pair": "{covered}/{total} customers",
  "manager_overview_no_product_customer_data": "No product customer data",
  "manager_overview_recent_calls": "Recent Calls",
  "manager_overview_no_hospital": "No hospital info",
  "manager_overview_no_recent_calls": "No recent calls",
  "manager_overview_select_member": "Select a member to view details",
  "manager_overview_period_month": "Monthly",
  "manager_overview_period_quarter": "Quarterly",
  "manager_overview_all_areas": "All Areas",
  "manager_overview_all_districts": "All Districts",
  "manager_overview_feedback_desc": "Feedback {count} · feedback rate {rate}",
  "manager_overview_reached_customer_desc": "Reached customers {count}",
  "manager_overview_content_open_desc": "Reached {reached} · target opened {opened} · avg {duration}",
  "manager_overview_content_reach_avg_desc": "Reached {reached} · avg read {duration}/article",
  "manager_overview_content_avg_read_desc": "Avg read {duration}/article",
  "manager_overview_content_avg_read_prefix": "Avg read ",
  "manager_overview_content_avg_read_suffix": "/article",
  "manager_overview_execution_rate_desc": "Execution rate {rate}",
  "manager_overview_total_suggestions_desc": "Total suggestions {count}",
  "manager_overview_call_feedback_completed": "Call Feedback Completed",
  "manager_overview_call_feedback_completed_desc": "{count} calls have feedback",
  "manager_overview_task_execution_completed": "Task Execution Completed",
  "manager_overview_task_execution_completed_desc": "Executed {executed} / total tasks {total}",
  "manager_overview_nba_process_completed": "NBA Handling Completed",
  "manager_overview_nba_process_completed_desc": "Accepted {accepted}, rejected {rejected}",
  "manager_overview_content_sent": "Content Sent",
  "manager_overview_content_sent_desc": "Reached {count} customers",
  "manager_overview_avg_duration_short": "Avg {duration}",
  "manager_overview_other": "Other",
  "manager_overview_unknown_product": "Unknown Product",
  "manager_overview_unknown_member": "Unknown Member",
  "manager_overview_target_coverage_rate": "Target Customer Coverage Rate",
  "manager_overview_target_customers": "Target Customers",
  "manager_overview_target_covered_customers": "Target Covered Customers",
  "manager_overview_abc_coverage_rate": "A/B/C Customer Coverage Rate",
  "manager_overview_abc_target_customers": "A/B/C Target Customers",
  "manager_overview_abc_covered_customers": "A/B/C Covered Customers",
  "manager_overview_call_count": "Call Count",
  "manager_overview_feedback_count": "Feedback Count",
  "manager_overview_feedback_rate": "Feedback Rate",
  "manager_overview_avg_open_duration": "Avg Viewing Duration",
  "manager_overview_content_reached_customers": "Content Reached Customers",
  "manager_overview_content_open_send_customers": "Content Open/Send Customers",
  "manager_overview_online_promotion_progress": "Online Promotion Progress",
  "manager_overview_promotion_open_count": "Opens",
  "manager_overview_online_promotion_note": "Article statistics exclude livestream- and questionnaire-related content. Send/open counts are deduplicated by customer + article each month, so repeated sends or opens of the same article by the same customer in one month count once.",
  "manager_overview_online_promotion_current_note": " Statistics are updated through yesterday and are not real-time.",
  "manager_overview_online_promotion_unavailable": "Online promotion progress is temporarily unavailable",
  "manager_content_customer_detail": "Content Customer Interactions",
  "manager_content_reached_customers": "Reached Customers",
  "manager_content_all": "All",
  "manager_content_opened": "Opened",
  "manager_content_unopened": "Not Opened",
  "manager_content_send_count": "Sent {count} times",
  "manager_content_open_count": "Opened {count} times",
  "manager_content_no_customers": "No customers received content in this period",
  "manager_content_load_error": "Failed to load customer content interactions. Please try again later.",
  "manager_overview_unit_customers": "{count} customers",
  "manager_overview_unit_calls": "{count} calls",
  "manager_overview_unit_open_send_times": "{opened}/{sent} times",
  "manager_overview_unit_seconds_per_article": "{count}/article",
  "manager_overview_unit_customers_suffix": "customers",
  "manager_overview_unit_calls_suffix": "calls",
  "manager_overview_unit_times_suffix": "times",
  "manager_overview_unit_seconds_per_article_suffix": "/article",
  "manager_overview_task_execution_rate": "Task Execution Rate",
  "manager_overview_nba_process_rate": "NBA Handling Rate",
  "manager_overview_typing_definitions_unavailable": "Physician segment definitions are temporarily unavailable",
  "manager_overview_product_target_unavailable": "Product target customer stats are temporarily unavailable",
  "manager_overview_team_detail_unavailable": "Team member details are temporarily unavailable",
  "manager_overview_subordinate_unavailable": "Subordinate territory data is temporarily unavailable",
  "manager_overview_no_subordinates": "No subordinate territories were found. Please confirm the current account has a subordinate team.",
  "manager_overview_call_stats_unavailable": "Subordinate call stats are temporarily unavailable",
  "manager_overview_feedback_stats_unavailable": "Subordinate call feedback stats are temporarily unavailable",
  "manager_overview_coverage_stats_unavailable": "Subordinate customer coverage stats are temporarily unavailable",
  "manager_overview_content_stats_unavailable": "Content push stats are temporarily unavailable",
  "manager_overview_content_open_stats_unavailable": "Content open stats are temporarily unavailable",
  "manager_overview_task_stats_unavailable": "Task execution stats are temporarily unavailable",
  "manager_overview_nba_suggestion_stats_unavailable": "NBA suggestion stats are temporarily unavailable",
  "manager_overview_nba_feedback_stats_unavailable": "NBA feedback stats are temporarily unavailable",
  "manager_overview_no_period_data": "{count} subordinates were found, but there is no execution data to display for the current period.",
  "manager_overview_recent_calls_unavailable": "Recent calls are temporarily unavailable",
  "kpi_analysis_title": "KPI Overview",
  "total_achievement_rate": "Overall Completion",
  "overall_achievement": "Overall Completion",
  "completed_count": "Completed",
  "target_count": "Target",
  "updated_at": "Updated",
  "statistics_as_of": "Statistics as of",
  "kpi_summary_desc": "Data is sourced from the Super Rep system and is for business process reference only. It does not represent official performance assessment or incentive calculation results.",
  "kpi_drill_customer_level_suffix": "",
  "kpi_drill_coverage_summary": "Customers covered this month",
  "kpi_drill_frequency_summary": "Customers meeting monthly call frequency",
  "kpi_drill_bind_summary": "Bound target customers",
  "kpi_drill_monthly_visits": "{count} calls this month",
  "kpi_drill_frequency_progress": "{current} / {target} calls this month",
  "kpi_drill_achieved": "On target",
  "kpi_drill_pending": "Below target",
  "kpi_more_suggestions_cta": "Get More KPI Suggestions",
  "kpi_more_suggestions_desc": "Send current results to AI Assistant for follow-up",
  "view_all": "View all",
  "kpi_target_short": "Target",
  "kpi_weekly_target_short": "Weekly Target",
  "kpi_completion_rate": "Completion",
  "kpi_threshold_reached": "Threshold met",
  "kpi_day_unit": "days",
  "kpi_calls_per_day_unit": "calls/day",
  "kpi_period_current": "Current",
  "kpi_period_day": "Day",
  "kpi_period_week": "Week",
  "kpi_period_month": "Month",
  "kpi_period_quarter": "Quarter",
  "kpi_section_customer_development": "Customer Development",
  "kpi_section_academic_interaction": "Academic Interaction",
  "kpi_section_digital_interaction": "Digital Interaction",
  "kpi_section_behavior_process": "Behavior & Process",
  "kpi_section_award_threshold": "Award Threshold",
  "kpi_target_customer_count": "Target Customers (Deduped)",
  "kpi_ab_customer_ratio": "A/B Customer Ratio",
  "kpi_abc_customer_coverage": "A/B/C Customer Coverage",
  "kpi_abc_customer_monthly_coverage_frequency": "A/B/C Monthly Call Frequency",
  "kpi_target_customer_bind_rate": "Target Customer Bind Rate",
  "kpi_quarterly_meetings": "Quarterly Meetings",
  "kpi_quarterly_sign_in_rate": "Quarterly E-sign-in Rate",
  "kpi_quarterly_content_push": "Quarterly Digital Content Push",
  "kpi_questionnaire_completion_rate": "Questionnaire Completion",
  "kpi_kol_content_push": "KOL Content Push",
  "kpi_monthly_working_days": "Monthly Working Days",
  "kpi_visit_plan_count": "Visit Plan Count",
  "kpi_plan_achievement_rate": "Plan Achievement",
  "kpi_abc_customer_dedup_count": "ABC Customer Dedup Count",
  "kpi_daily_face_to_face_calls": "Daily Face-to-face Calls",
  "kpi_visit_count": "Calls",
  "kpi_new_user_expansion": "New Users",
  "kpi_meeting_coverage": "Meetings",
  "kpi_academic_promotion": "Academic Promo",
  "kpi_visit_coverage": "Call Coverage",
  "kpi_task_execution": "Tasks Executed",
  "kpi_deal_progression": "Deal Progression",
  "perception_action_suggestions": "Recommended Actions",
  "perception_online_tasks": "Online Tasks",
  "perception_no_tasks": "No tasks yet",
  "wechat_bind_status_title": "WeChat Binding Status",
  "wechat_bind_label": "WeChat Binding:",
  "wechat_bind_pending_unbind": "Unbind requested",
  "wechat_bind_approve_unbind": "Approve Unbind",
  "wechat_bind_bound": "Bound",
  "wechat_bind_date_suffix": "bound",
  "wechat_bind_unbind_action": "Unbind",
  "wechat_bind_unbound": "Not bound",
  "wechat_consent_label": "Informed Consent:",
  "wechat_consent_pending_cancel": "Consent cancellation requested",
  "wechat_consent_approve_cancel": "Approve Cancellation",
  "wechat_consent_signed": "Signed",
  "wechat_consent_date_suffix": "signed",
  "wechat_consent_cancel_action": "Cancel Signature",
  "wechat_consent_unsigned": "Not signed",
  "wechat_content_sent": "Content Sent:",
  "wechat_content_opened": "Content Opened:",
  "wechat_interaction_history_title": "Online Interaction History",
  "wechat_history_open": "Opened",
  "wechat_history_sent": "Sent",
  "wechat_history_viewed": "Viewed",
  "wechat_unbind_dialog_title": "Unbind WeChat",
  "wechat_unbind_dialog_message_line1": "Please confirm whether you want to remove the binding between this HCP and the currently linked WeChat account.",
  "wechat_unbind_dialog_message_line2": "This action cannot be restored. You will need to resend content and re-establish the binding after the HCP opens and confirms it through WeChat forwarding.",
  "wechat_unsign_dialog_title": "Cancel Consent",
  "wechat_unsign_dialog_message": "Please confirm whether you want to cancel this HCP's informed consent.",
  "wechat_duration_hour": "h",
  "wechat_duration_minute": "m",
  "wechat_duration_second": "s",
  "wechat_notify_unbind_type": "WeChat unbinding",
  "wechat_notify_unsign_type": "informed consent cancellation",
  "wechat_notify_message_title": "[{type} Request] {user}",
  "wechat_notify_message_content": "Your colleague {user} requests {type} for Dr. {physician} {institution}. Click <a href='{url}'>here</a> to proceed.",
  "smart_summary": "Smart Summary",
  "refresh": "Refresh",
  "detailed_analysis": "Detailed Analysis",
  "no_detail_content": "No detailed content",
  "further_understanding": "Learn more",
  "ask_something_else": "I want to ask something else...",
  "follow_up_q1": "Which customers need priority calls?",
  "follow_up_q2": "What are the main reasons for dynamic changes in the last month?",
  "follow_up_q3": "How should I adjust the call rhythm for next month?",
  "based_on_recent_updates": "Based on recent updates, ",
  "today": "Today",
  "tomorrow": "Tomorrow",
  "no_co_visit": "No Co-calls",
  "visit_history": "Call History",
  "no_visit": "No Calls",
  "no_visit_data": "No Call Data",
  "no_co_visit_today": "No Co-calls today",
  "no_visit_today": "No Calls today",
  "new_action": "New",
  "year": "Year",
  "back_doctor_list": "Back",
  "strategy_map": "Strategy Map",
  "customer_persona": "Persona",
  "basic_info": "Basic Info",
  "latest_news": "Latest News",
  "academic_details": "Academic",
  "timeline_show_legend": "Legend",
  "timeline_hide_legend": "Hide Legend",
  "timeline_legend_internal": "Internal",
  "timeline_legend_online": "Online",
  "timeline_legend_external": "External",
  "timeline_legend_academic": "Academic",
  "timeline_expand": "Expand",
  "timeline_collapse": "Collapse",
  "timeline_detail": "Detail",
  "timeline_unknown_date": "Unknown",
  "timeline_read_duration": "Read {duration}",
  "timeline_platform_sent": "Sent",
  "timeline_content_send_title": "Content Sent",
  "timeline_content_open_title": "Content Opened",
  "timeline_type_mr_call": "Sales Call",
  "timeline_type_msl_call": "Medical Call",
  "timeline_type_internal_meeting": "Internal Meeting",
  "timeline_type_msl_insight": "Medical Insight",
  "timeline_type_content_send": "Content Sent",
  "timeline_type_content_open": "Content Opened",
  "timeline_type_wechat_article": "WeChat",
  "timeline_type_patient_article": "Patient Article",
  "timeline_type_patient_live": "Patient Live",
  "timeline_type_third_party_meeting": "3rd-Party Meeting",
  "timeline_type_publication": "Publication",
  "timeline_type_clinical_trial": "Trial",
  "timeline_type_national_fund": "Grant",
  "timeline_type_award": "Award",
  "timeline_type_guideline": "Guideline",
  "timeline_type_patent": "Patent",
  "timeline_purpose_delivering_product_message": "Deliver Product Message",
  "timeline_purpose_information_collection": "Information Collection",
  "timeline_purpose_meeting_follow_up": "Meeting Follow-up",
  "timeline_purpose_reminding": "Reminder",
  "timeline_purpose_nrdl": "NRDL",
  "timeline_purpose_others": "Other",
  "timeline_purpose_mkt_activity": "Marketing Activity",
  "timeline_purpose_positive": "Positive Response",
  "details_tab_persona": "Persona",
  "details_tab_strategy": "Strategy",
  "details_tab_basics": "Basics",
  "details_tab_news": "Timeline",
  "details_tab_academic": "Academic",
  "details_tab_wechat": "WeChat",
  "day": "Day",
  "ai_summary_title": "AI Summary",
  "ai_nba_suggestions_title": "AI Next Best Action(s)",
  "ai_nba_reason_label": "Reason: ",
  "ai_nba_detail_label": "Details: ",
  "ai_nba_next_step_label": "Next step: ",
  "ai_nba_default_title": "Next Action Suggestion",
  "ai_nba_action_type_call": "Call",
  "ai_nba_action_type_meeting": "Meeting",
  "ai_nba_action_type_content": "Content",
  "ai_nba_action_type_content_push": "Content Push",
  "ai_nba_action_type_meeting_invite": "Meeting Invite",
  "ai_nba_action_type_meeting_speaker": "Speaker Opportunity",
  "ai_nba_action_type_default": "Suggestion",
  "ai_nba_trigger_type_coverage_gap": "Coverage Gap",
  "ai_nba_trigger_type_positive_feedback": "Positive Feedback",
  "ai_nba_trigger_type_objection_followup": "Objection Follow-up",
  "ai_nba_trigger_type_digital_engagement": "Digital Engagement",
  "ai_nba_trigger_type_content_interest": "Content Interest",
  "ai_nba_trigger_type_meeting_opportunity": "Meeting Opportunity",
  "ai_nba_trigger_type_doctor_dynamic": "Doctor Dynamic",
  "ai_nba_trigger_type_sales_trend": "Sales Trend",
  "ai_nba_trigger_type_key_customer_coverage_gap": "Key Customer Coverage",
  "ai_nba_trigger_type_product_sales_trend": "Product Sales Trend",
  "ai_nba_product_label": "Product",
  "ai_nba_key_customer": "Key Customer",
  "ai_nba_customer_level": "Level {level}",
  "ai_nba_product_sales_signal_continuous_decline": "Continuous Decline",
  "ai_nba_product_sales_signal_sales_drop": "Sales Drop",
  "ai_nba_product_sales_signal_target_gap": "Target Gap",
  "ai_nba_product_sales_signal_abnormal_fluctuation": "Abnormal Fluctuation",
  "ai_interaction_summary": "AI Interaction Summary",
  "ai_action_plan_title": "AI Next-Best-Actions",
  "ai_action_plan_follow_up": "Explore Next Step",
  "ai_action_plan_create_visit": "Create Call",
  "ai_action_plan_create_meeting": "Create Meeting",
  "ai_action_plan_create_regional_meeting": "Create Meeting",
  "ai_action_plan_default_doctor": "this physician",
  "ai_action_plan_item_1_title": "1 Track Hospital Sales",
  "ai_action_plan_item_1_desc": "The system detected a continued decline in Brintellix sales at Dr. Paris's hospital. Confirm formulary access and inventory status first.",
  "ai_action_plan_item_2_title": "2 Evaluate Speaker Potential",
  "ai_action_plan_item_2_desc": "Relationship network analysis suggests Dr. Paris currently influences about 18 physicians across related departments and already has credible in-hospital reach.\nConsider involving the physician in department sharing sessions or case discussions as a gradual path toward speaker development.\nRecommended topic: Clinical identification and treatment strategies for depression with anxiety",
  "ai_action_plan_item_3_title": "3 Launch Academic Session",
  "ai_action_plan_item_3_desc": "Consider a department or in-hospital meeting to strengthen Dr. Paris's acceptance of Brintellix.\nBased on the influence network, Dr. Bitao Bu is recommended as the speaker from the same department.",
  "ai_action_plan_item_4_title": "4 Advance Perception Stage",
  "ai_action_plan_item_4_desc": "The system currently places Dr. Paris in the \"trial user\" stage for product perception, and that stage has lasted for some time. Re-share the clinical evidence piece \"Current Clinical Management and Optimization Strategies for Depression with Anxiety\" during the next call and reassess whether the physician's perception has shifted.",
  "ai_action_plan_caojie_stage_1_title": "Recommend a Call to Learn the Latest In-hospital Diagnosis and Treatment Updates",
  "ai_action_plan_caojie_stage_1_desc": "The system detected recent academic or clinical activity within the hospital, suggesting a potential window for updated physician awareness.",
  "ai_action_plan_caojie_stage_2_title": "Follow Up to Explore Inpatient Experience in More Depth",
  "ai_action_plan_caojie_stage_2_desc": "During the last discussion, the physician mentioned initial inpatient use, creating a good opportunity to gather deeper clinical feedback.",
  "ai_action_plan_caojie_stage_2_desc_prefix": "During the last discussion",
  "ai_action_plan_caojie_stage_2_desc_suffix": ", the physician mentioned initial inpatient use, creating a good opportunity to gather deeper clinical feedback.",
  "ai_action_plan_caojie_stage_3_title": "Recommend the Physician as a Regional Academic Speaker to Share Real-world Experience",
  "ai_action_plan_caojie_stage_3_desc": "The physician has formed positive clinical feedback and now has both real-world experience and academic influence suitable for broader academic communication.",
  "ai_action_plan_caojie_extra_visit_title": "Reinforce Product Perception in the Next Call",
  "ai_action_plan_caojie_extra_visit_desc": "The system currently places Dr. Cao Jie in the \"trial user\" stage for product perception, and that stage has persisted for some time. Re-share the clinical evidence piece \"Current Clinical Management and Optimization Strategies for Depression with Anxiety\" during the next call and reassess whether the physician's perception has shifted.",
  "ai_action_plan_previous_visit_button": "Call {date}",
  "ai_action_plan_create_meeting_prompt": "I want to create a department meeting for {name} (Physician ID: {physicianId}). The meeting theme is improving acceptance of Brintellix, and the recommended speaker is Dr. Bitao Bu.",
  "ai_action_plan_create_regional_meeting_prompt": "I want to create a regional academic meeting for {name} (Physician ID: {physicianId}) to share real-world clinical experience and support broader academic communication.",
  "ai_action_plan_follow_up_prompt": "I want to understand the next-step action recommendations for {name} (Physician ID: {physicianId}).",
  "no_feedback_summary": "No feedback summary available",
  "further_inquiry_suggestions": "Further Inquiry Suggestions",
  "input_further_question": "Please enter further questions...",
  "other": "Other",
  "risk": "Risk",
  "barrier": "Barrier",
  "difficulty": "Difficulty",
  "opportunity": "Opportunity",
  "advantage": "Advantage",
  "hospital_info": "HCO Info",
  "nmpa_details": "NMPA Details",
  "profile_professional_title": "Title",
  "profile_admin_title": "Admin Role",
  "profile_academic_title": "Academic Role",
  "profile_social_roles": "Social Roles",
  "office_tier_international": "International",
  "office_tier_national": "National",
  "office_tier_provincial": "Provincial",
  "office_tier_municipal": "Municipal",
  "profile_key_customer_top": "Key",
  "profile_key_customer_bottom": "HCP",
  "kol_speaker_details": "KOL/Speaker Details",
  "national_level": "National Level",
  "city_level": "City Level",
  "city_region_level_txt": "City/Regional Level",
  "hospital_level": "Hospital Level",
  "national_kol": "National",
  "regional_kol": "Regional",
  "level_kol": "KOL",
  "level_speaker": "Speaker",
  "no_explicit_feedback": "No explicit feedback",
  "no_feedback": "No feedback",
  "based_on_doctor_feedback": "Based on recent feedback from {name} at {institution}, please further analyze: {question}",
  "based_on_doctor": "Based on this physician's recent feedback, please further analyze: {question}",
  "recent_visit_feedback_q": "recent call feedback, {question}",
  "generated_by_ai": "Generated by AI",
  "voice_input": "Voice Input",
  "stop_recording": "Stop Recording",
  "ai_listening": "AI Listening",
  "speak_question": "Please speak your question...",
  "max_60_seconds": "Max 60 seconds",
  "end_recording": "End Recording",
  "next_action_suggestions": "Next Action Suggestions",
  "quarterly_promotion_progress": "Quarterly Progress",
  "view_details": "View Details",
  "deadline": "Deadline",
  "completed_forwards": "Completed Forwards",
  "quarterly_target_forwards": "Quarterly Target",
  "open": "Open",
  "refresh_batch": "Redo",
  "refresh_ai_confirm_title": "Re-evaluate Suggestions",
  "refresh_ai_confirm_message": "Do you want AI to re-evaluate the current suggestions? This may take more than 1 minute.",
  ...gbaAdminExtra
}
